<template>
<div class="recorderdetail" name="recorderdetail">
  <topNav v-show="topShow" :title="title"></topNav>
  <div class="informinfo" v-for="(item,index) in payParams" :key="index">
    <div class="price">
        <div class="companyname">{{item.parkingname}}</div>
        <div class="fee">{{item.parkingfee}}</div>
        <p><span>{{item.dateIn}}</span>至<span>{{item.dateOut}}</span></p>
    </div>
    <div class="orderdetail">
      <p><span class="leftinfo">车牌号</span><span class="rightinfo">{{item.cardno}}</span></p>
      <p><span class="leftinfo">停车时长</span><span class="rightinfo">{{item.parkingtimes}}</span></p>
      <p><span class="leftinfo">支付金额</span><span class="rightinfo">{{item.parkingfee}}</span></p>
    </div>
  </div>

</div>

</template>
<script>
import topNav from "../topnav/topnav"
export default {
  name: 'recorderdetail',
  components:{
     topNav,
  },
  data() {
    return {
      title:"停车记录详情",
      payParams:[],
      topShow:true
    }
  },
  created(){
    let cardno=this.$route.params.cardno;
    let parkingfee=this.$route.params.parkingfee;
    let parkingname=this.$route.params.parkingname;
    let parkingtimes=this.$route.params.parkingtimes;
    let dateOut=this.$route.params.dateOut;
    let dateIn=this.$route.params.dateIn;
    // let paymode=this.commonUtil.getCookie("paymode");
    this.payParams.push({
      "cardno":cardno,//车牌号
      "parkingfee":parkingfee,//支付费用
      'parkingname':parkingname,//停车场
      'parkingtimes':parkingtimes,//停车总时长
      'dateOut':dateOut,//出场时间
      'dateIn':dateIn,//入场时间
      })
  },

}
</script>
<style>
.recorderdetail{
  background: white;
  height: 100%;
  width: 100%;
}
.price,.orderdetail{
  /* background: white; */
}
.orderdetail{
  padding-bottom: 6px;
}
.orderinfo{
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  padding-top: 6px;
}
.price{
  padding: 23px 0;
  font-size: 15px;
}
.fee{
  padding:8px 0;
  font-size: 37px;
  margin-top: 9px;
  color:#4687f8;
}
.informinfo p{
  width:92%;
  margin: 0 auto;
  padding:10px 0;
  font-size: 15px;
}
.informinfo .leftinfo{
  display:inline-block;
  width: 30%;
  text-align: left;
}
.informinfo .rightinfo{
  display:inline-block;
  width: 70%;
  text-align: right;
}
.opertion{
  margin-top: 10px;
  border-top: 1px solid #f5f5f5;
}
</style>




// WEBPACK FOOTER //
// src/components/my/recorderdetail.vue